var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('header',[_c('ConfettiLogo'),_vm._v(" "),_c('h1',[_vm._v("buzzer")]),_vm._v(" "),_c('h3',[_vm._v("by confetti")])],1),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('ConfettiNotice')],2)}
var staticRenderFns = []

export { render, staticRenderFns }